/* eslint no-console: "off" */
/**
 * 지도관제, 목록관제에서 사용되는 소켓 구독 모듈
 */
import io from 'socket.io-client';
import { emitEvent } from '@/eventBus';
import socketEvent from '@/constants/socketEvent';
import eventBusEvent from '@/constants/eventBusEvent';
export default class WebSocketMapControl {
    /** 구독 */
    SUBSCRIBED = 'SUBSCRIBED';
    /** 구독 해지 */
    UNSUBSCRIBED = 'UNSUBSCRIBED';
    subscribeStates = {
        [this.SUBSCRIBED]: this.SUBSCRIBED,
        [this.UNSUBSCRIBED]: this.UNSUBSCRIBED,
    };
    subscribeState;
    token;
    subscribeHubInfo;
    currentSubscribeType = '';
    /** emit 명칭 (총판, 허브), 서버로 보내는 이벤트 */
    emitEventName = {
        DIST: socketEvent.roomUpdatedDistributorTopic,
        HUB: socketEvent.roomUpdatedHubTopic,
    };
    /** on 명칭, 서버에서 받는 이벤트 명칭 */
    onEventName = [
        socketEvent.recvEvtOrdersUpdated,
        socketEvent.recvEvtFulfillmentUpdated,
    ];
    /** 핸들러 종류 */
    handlerType = [
        // 주문
        eventBusEvent.Socket_handlePushOrder,
        // 풀필먼트
        eventBusEvent.Socket_handlePushFulfillment,
    ];
    socket;
    log = [
        '🎁 주문',
        '🛵 수행정보',
    ];
    /** 소켓 URL */
    url;
    /** 소켓 옵션 */
    options;
    constructor({ token = '', isMapControlPage = false, }) {
        this.subscribeState = this.subscribeStates.UNSUBSCRIBED;
        this.token = token;
        // 현재 구독중인 허브, 총판 id (총판, 허브 구분 없음)
        this.subscribeHubInfo = [];
        // 현재 구독 타입 허브(HUB) or 총판(DIST)
        this.currentSubscribeType = '';
        this.url = window.Cypress
            // fake-socket-server.ts 참조
            ? 'http://localhost:3000'
            : `${process.env.BASE_PUSH_SERVER_URL}/push?token=${this.token}`;
        // 지도관제일 경우 url에 isMapControl 추가
        if (isMapControlPage) {
            const u = new URL(this.url);
            const s = new URLSearchParams(u.search);
            s.append('isMapControl', 'true');
            u.search = s.toString();
            this.url = u;
        }
        this.options = window.Cypress
            ? {
                transports: [
                    'websocket',
                ],
                reconnection: false,
                timeout: 10000,
                autoConnect: true,
            }
            : {
                transports: [
                    'websocket',
                ],
                reconnection: true,
                reconnectionAttempts: Infinity,
                reconnectionDelay: 1000,
                reconnectionDelayMax: 5000,
                randomizationFactor: 0.5,
                timeout: 20000,
                autoConnect: true,
            };
    }
    /**
     * 구독한 이벤트 처리 연동
     * @param isUnsubscribe
     */
    _onEvent(isUnsubscribe = undefined) {
        this.onEventName.forEach((event, index) => {
            // off
            if (isUnsubscribe) {
                // console.log('[OFF]', event);
                this.socket.off(event);
            }
            // on
            if (!isUnsubscribe) {
                this.socket.on(event, (data) => {
                    // chnagedAt과 updatedAt을 분리한 사유 유실... 일단 둘다 사용하기로.
                    // 되도록 updatedAt을 사용하는 방향으로 진행.
                    // updatedAt === changedAt
                    // eslint-disable-next-line no-param-reassign
                    data.updatedAt = data.changedAt;
                    emitEvent(this.handlerType[index], data);
                });
            }
        });
    }
    /**
     * 프론트가 서버에 구독 요청
     * @param isUnsubscribe 토픽 구독 해지 여부
     */
    _emitEvent(isUnsubscribe = undefined) {
        const emitType = isUnsubscribe
            ? socketEvent.unsubTopic
            : socketEvent.subTopic;
        const isSubscribeText = isUnsubscribe
            ? '❌ 해지'
            : '🟢 구독';
        const css = isUnsubscribe
            ? 'font-size:14px;color:#f00;font-weight:bold'
            : 'font-size:14px;color:green;font-weight:bold;';
        const topic = this.emitEventName[this.currentSubscribeType];
        this.subscribeHubInfo.forEach(({ id: param }) => {
            this.socket.emit(emitType, {
                topic,
                param,
            });
            console.log(`%c ${isSubscribeText} Emit: ${topic}: ${this.currentSubscribeType}(${param})`, css);
        });
    }
    /**
     * 소켓 인스턴스 조회
     */
    getSocket() {
        return this.socket;
    }
    /**
     * 구독 정보 설정
     * @param _subscribeHubInfo 구독 허브 or 총판 아이디와 타입 정보
     */
    setSubscribeInfo(_subscribeHubInfo) {
        this.currentSubscribeType = _subscribeHubInfo[0].type;
        this.subscribeHubInfo = _subscribeHubInfo;
    }
    /**
     * 소켓 초기화
     */
    init() {
        this.socket = io(`${this.url}`, this.options)
            .on('error', () => {
            console.log('error');
        })
            .on('connect_timeout', () => {
            console.log('connect_timeout');
        })
            .on('connect_error', () => {
            console.log('connect_error');
        })
            .on('connect_failed', () => {
            console.log('connect_failed');
        })
            .on('connect', () => {
            console.log('🔌 connect');
        })
            .on('disconnect', () => {
            console.log('👋 disconnect');
        });
        return this.socket;
    }
    /**
     * 연결
     */
    connect() {
        this.socket.connect();
    }
    /**
     * 소켓 연결 끊기
     */
    disconnect() {
        this.socket.disconnect();
    }
    /**
     * 구독
     * @param newSubType 허브, 총판 HUB, DIST
     * @param newSubscribeHubInfo 허브, 총판 코드 리스트
     */
    subscribe(newSubType, newSubscribeHubInfo) {
        // 구독 상태면 이전 구독 제거
        if (this.subscribeState === this.subscribeStates.SUBSCRIBED) {
            this.unsubscribe();
        }
        this.currentSubscribeType = newSubType || this.currentSubscribeType || 'HUB';
        this.subscribeHubInfo = newSubscribeHubInfo || this.subscribeHubInfo || [];
        this._onEvent();
        this._emitEvent();
        this.subscribeState = this.subscribeStates.SUBSCRIBED;
    }
    /**
     * 구독 해지
     */
    unsubscribe() {
        if (!this.subscribeHubInfo.length) {
            return;
        }
        this._onEvent(true);
        this._emitEvent(true);
        this.subscribeState = this.subscribeStates.UNSUBSCRIBED;
    }
}
